module.exports = "/assets/images/facebook_f060e5.svg";